export default {
  name: 'calculator',
  path: '/calculator?isNew',
  decodeParams: ({ isNew }) => ({ isNew: isNew === 'true' }),
  loadComponent: () => import('./index')
};
